import { render, staticRenderFns } from "./ShipsEffort.vue?vue&type=template&id=378fff87&"
import script from "./ShipsEffort.vue?vue&type=script&lang=js&"
export * from "./ShipsEffort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports